import React, { Component } from "react";
import BASE_URL from "../../config";

export default class Team extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      role: "",
      phone: "",
      photo: null,
      team: [],

      // 👇 Add this
      selectedImage: null,
    };
  }

  componentDidMount() {
    this.getTeam();
  }

  // 📌 Fetch team data
  getTeam = () => {
    fetch(`${BASE_URL}/api/getTeam.php`)
      .then((res) => res.json())
      .then((data) => this.setState({ team: data }))
      .catch((err) => console.error("Fetch error:", err));
  };

  // 📌 Handle input
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // 📌 Handle file
  handleFile = (e) => {
    this.setState({ photo: e.target.files[0] });
  };

  // 📌 Submit form
  handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", this.state.name);
    formData.append("role", this.state.role);
    formData.append("phone", this.state.phone);
    formData.append("photo", this.state.photo);

    fetch(`${BASE_URL}/api/addTeam.php`, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.text())
      .then((data) => {
        alert(data);
        this.getTeam();
      })
      .catch((err) => console.error(err));
  };

  // 📌 Delete
  handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete?")) return;

    const formData = new FormData();
    formData.append("id", id);

    fetch(`${BASE_URL}/api/deleteTeam.php`, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.text())
      .then((data) => {
        alert(data);
        this.getTeam();
      })
      .catch((err) => console.error(err));
  };

  render() {
    return (
      <div className="team-page">
        {/* FORM */}
        <div className="form-container">
          <h2>સભ્ય ઉમેરો</h2>

          <form onSubmit={this.handleSubmit} className="form">
            <label>નામ</label>
            <input
              type="text"
              name="name"
              placeholder="નામ"
              onChange={this.handleChange}
              required
            />

            <label>રોલ</label>
            <input
              type="text"
              name="role"
              placeholder="રોલ"
              onChange={this.handleChange}
              required
            />

            <label>ફોન નંબર</label>
            <input
              type="tel"
              name="phone"
              placeholder="ફોન નંબર"
              onChange={this.handleChange}
              required
            />

            <label>ફોટો</label>
            <input type="file" onChange={this.handleFile} />

            <button type="submit">Add</button>
          </form>
        </div>

        {/* TABLE */}
        {/* TEAM CARDS */}
        <div className="team-members-gallery">
          <hr></hr>
          <h4>સભ્ય યાદી </h4>

          <div className="team-members-grid">
            {this.state.team.map((item) => (
              <div className="team-member-card" key={item.id}>
                <button
                  className="team-member-delete-btn"
                  onClick={() => this.handleDelete(item.id)}
                >
                  ×
                </button>

                <img
                  className="team-member-image"
                  src={`${BASE_URL}/uploads/${item.photo}`}
                  alt={item.name}
                  onClick={() =>
                    this.setState({
                      selectedImage: `${BASE_URL}/uploads/${item.photo}`,
                    })
                  }
                />

                <div className="team-member-details">
                  <h3 className="team-member-name">{item.name}</h3>
                  <p className="team-member-role">{item.role}</p>
                  <p className="team-member-phone">{item.phone}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 👇 IMAGE POPUP MODAL */}
        {this.state.selectedImage && (
          <div
            className="image-modal"
            onClick={() => this.setState({ selectedImage: null })}
          >
            <div
              className="image-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                className="close-btn"
                onClick={() => this.setState({ selectedImage: null })}
              >
                ×
              </button>

              <img src={this.state.selectedImage} alt="Preview" />
            </div>
          </div>
        )}
      </div>
    );
  }
}
